import { useEffect, useState } from "react";
import usePost from "../../hooks/usePost";
import { changeMethod, archiveProject, projectDetails } from "../../endpoints";
import ProjectDetail from "./ProjectDetail";
import axios from "axios";

interface Props {
  project: string;
  id: string;
  refrence: string;
  methode: string;
  customer: string;
  status: string;
  factuur: string;
  creation: string;
}

interface data {
  totalhours: number; //hours spent on project
  billablehours: number; //billable hours on project
  unbilliblehours: number; //unbillable hours on project
  plannedhours: number; //planned hours on project
  unpayed: number; //money that still has to be payed by customer
  payed: number; //money that has been payed by customer
  afgeboekt: number;
  totalcosts: number; //total sallary costs of the project
  hours: number; //hours spent in salary cost
  spending: number; //money employees spent on the project
  rides: number; //costs of the km riden
  totalkm: number; //total km riden in project
  budget: string; //the budget of the project
}

const Project = ({
  project,
  id,
  refrence,
  methode: initialMethode,
  customer,
  status,
  factuur,
  creation,
}: Props) => {
  const [methode, setMethode] = useState(initialMethode);
  const [isDetailVisible, setIsDetailVisible] = useState(false);
  const { patch } = usePost();
  const endpoint = changeMethod;
  const endpoint2 = archiveProject;
  const endpoint3 = projectDetails;
  const apiKey = process.env.REACT_APP_API_KEY;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [detailData, setDetailData] = useState<data | null>(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const intervalId = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(intervalId);
  }, []);

  const creationTime = new Date(creation).getTime();
  const elapsedMs = Number.isNaN(creationTime)
    ? null
    : Math.max(0, now - creationTime);
  const creationDisplay =
    elapsedMs === null
      ? creation
      : `${String(Math.floor(elapsedMs / 3600000)).padStart(2, "0")}:${String(
          Math.floor((elapsedMs % 3600000) / 60000),
        ).padStart(2, "0")}:${String(Math.floor((elapsedMs % 60000) / 1000)).padStart(2, "0")}`;

  // let statusClass =
  //   "rounded-3xl bg-gray-200 text-gray-900 text-center w-fit px-3 py-1";
  // if (status === "Archived") {
  //   statusClass =
  //     "rounded-3xl bg-gray-200 text-gray-900 text-center w-fit px-3 py-1";
  // } else if (status === "Ready") {
  //   statusClass =
  //     "rounded-3xl bg-green-200 text-green-900 text-center w-fit px-3 py-1";
  // } else if (status === "Active") {
  //   statusClass =
  //     "rounded-3xl bg-blue-200 text-blue-900 text-center w-fit px-3 py-1";
  // }

  // let factuurClass =
  //   "rounded-3xl bg-gray-200 text-gray-900 text-center w-fit px-3 py-1";
  // if (factuur === "Gefactureerd") {
  //   factuurClass =
  //     "rounded-3xl bg-green-200 text-green-900 text-center w-fit px-3 py-1";
  // } else if (factuur === "Niet gefactureerd") {
  //   factuurClass =
  //     "rounded-3xl bg-orange-50 border-2 border-orange-200 text-orange-900 text-left w-fit px-3 py-1";
  // } else if (factuur) {
  //   factuurClass =
  //     "rounded-3xl bg-gray-200 text-gray-900 text-center w-fit px-3 py-1";
  // }

  const handleMethodeChange = async (
    e: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    const newMethod = e.target.value;
    setMethode(newMethod);
    console.log(id);

    try {
      await patch(endpoint, {
        id: id,
        method: newMethod,
      });
      console.log("Payment method updated successfully");
    } catch (error) {
      console.error("Patch failed:", error);
    }
  };

  const handleArchivePress = async (e: React.MouseEvent<HTMLButtonElement>) => {
    try {
      await patch(endpoint2, {
        id: id,
      });
      console.log("Payment method updated successfully");
      window.location.reload();
    } catch (error) {
      console.error("Patch failed:", error);
    }
  };

  const toggleDetailVisibility = async () => {
    if (!isDetailVisible) {
      setDetailData(null);

      try {
        const params = {
          project_id: id,
        };
        const response = await axios.get(baseUrl + endpoint3, {
          params: params,
          headers: {
            Authorization: apiKey,
          },
        });
        if (response.data.results) {
          setDetailData(response.data.results[0]);
        } else if (Array.isArray(response.data)) {
          setDetailData(response.data[0]);
        } else {
          setDetailData(response.data);
        }
      } catch (error: any) {
        console.error("There was an error!", error);
      }
    } else {
      setDetailData(null);
    }

    setIsDetailVisible(!isDetailVisible);
  };

  return (
    <>
      <div className="w-full text-black border-b-2 border-gray-300 p-2 flex items-center text-sm hover:bg-gray-50">
        <p className="w-[30%] pr-[2%]">{project}</p>
        <p className="w-[20%]">{customer}</p>
        <p className="w-[10%]">{refrence}</p>
        <div className="w-[12%]">
          <select
            className="w-11/12 rounded-xl border py-2"
            value={methode}
            onChange={handleMethodeChange}
          >
            <option value="None">------</option>
            <option value="CustomerHourlyRate">
              Nacalculatie (klanttarief)
            </option>
            <option value="ProjectHourlyRate">
              Nacalculatie (projecttarief)
            </option>
            <option value="UserHourlyRate">
              Nacalculatie (medewerkertarief)
            </option>
            <option value="TaskHourlyRate">
              Nacalculatie (activiteittarief)
            </option>
            <option value="ProjectRate">Fixed-price</option>
            <option value="NoInvoicing">Niet-factureerbaar</option>
          </select>
        </div>
        <p className="w-[10%] text-center">{creationDisplay}</p>
        <div className="w-[13%] text-right flex flex-col ml-auto">
          <button
            type="button"
            onClick={toggleDetailVisibility}
            className="rounded-md border w-fit px-2 py-1 ml-auto hover:bg-gray-100"
          >
            Details
          </button>
          {/* <button
          type="button"
          className="border rounded-md w-fit px-2 py-1 ml-auto hover:bg-gray-100"
        >
          Gefactureerd
        </button> */}
          <button
            type="button"
            onClick={handleArchivePress}
            className="border rounded-md w-fit px-2 py-1 ml-auto hover:bg-gray-100"
          >
            Archief
          </button>
        </div>
      </div>
      {isDetailVisible && (
        <ProjectDetail
          onClose={() => setIsDetailVisible(false)}
          totalhours={detailData?.totalhours || 0}
          billablehours={detailData?.billablehours || 0}
          unbilliblehours={detailData?.unbilliblehours || 0}
          plannedhours={detailData?.plannedhours || 0}
          unpayed={detailData?.unpayed || 0}
          payed={detailData?.payed || 0}
          afgeboekt={detailData?.afgeboekt || 0}
          totalcosts={detailData?.totalcosts || 0}
          hours={detailData?.hours || 0}
          spending={detailData?.spending || 0}
          rides={detailData?.rides || 0}
          totalkm={detailData?.totalkm || 0}
          budget={detailData?.budget || ""}
        />
      )}
    </>
  );
};

export default Project;
